module.exports = __webpack_public_path__ + "img/news-5.f47d54d9.png";